import { initialStateInfoFiscal } from "../initialStates/infoFiscal";

class HandleTaxNotaFIscal {
  handleValues(infoFiscal, objectIcms) {
    const newInfoFiscal = {
      icms: [
        { ...infoFiscal.icms[0] },
      ],
      ipi: [
        { ...infoFiscal.ipi[0] },
      ],
      pis: [
        { ...infoFiscal.pis[0] },
      ],
      cofins: [
        { ...infoFiscal.cofins[0] },
      ],
      issqn: [
        { ...infoFiscal.issqn[0] },
      ],
      ibs_cbs: [
        { ...infoFiscal.ibs_cbs[0] },
      ],
      informacoes_fisco: infoFiscal.informacoes_fisco,
      informacoes_complementares: infoFiscal.informacoes_complementares,
    }

    const valuesToRemove = objectIcms[newInfoFiscal.icms[0].situacao_tributaria]

    for (const value in valuesToRemove) {
      if (!valuesToRemove[value]) {
        delete newInfoFiscal.icms[0][value]
      }
    }

    return this.handleAliquots(this.handleIbsCbs(newInfoFiscal));
  }

  clearTax() {
    const result = {
      id: "",
      ref: "",
      descricao: "",
      idCategoriaRef: null,
      flags: { isManual: false, enableCreditoPresumido: false, enableIssqn: false },
      refObject: {
        icms: [
          {
            tipo_tributacao: "simples_nacional",
            cenario: "saida_dentro_estado",
            tipo_pessoa: "fisica",
            nao_contribuinte: false,
            codigo_cfop: "5102",
            situacao_tributaria: "102",
            aliquota_credito: "",
            aliquota_icms: [
              {
                estado: "",
                aliquota: "0.00",
              },
            ],
            aliquota_mva: [
              {
                estado: "",
                aliquota: "0.00",
              },
            ],
            aliquota_fcp: [
              {
                estado: "",
                aliquota: "0.00",
              },
            ],
            aliquota_fcp_st: [
              {
                estado: "",
                aliquota: "0.00",
              },
            ],
            aliquota_diferimento: "0.00",
            aliquota_diferimento_fcp: "0.00",
            aliquota_reducao: "0.00",
            aliquota_reducao_st: "0.00",
            motivo_desoneracao: "9",
            motivo_desoneracao_st: "9",
            beneficio_fiscal: [
              {
                estado: "",
                codigo: "",
              },
            ],
          },
        ],
        ipi: [
          {
            cenario: "padrao",
            tipo_pessoa: "fisica",
            situacao_tributaria: "99",
            codigo_enquadramento: "999",
            aliquota: "0.00",
          },
        ],
        pis: [
          {
            cenario: "padrao",
            tipo_pessoa: "fisica",
            situacao_tributaria: "99",
            aliquota: "0.00",
          },
        ],
        cofins: [
          {
            cenario: "padrao",
            tipo_pessoa: "fisica",
            situacao_tributaria: "99",
            aliquota: "0.00",
          },
        ],
        issqn: [
          {
            cenario: "",
            tipo_pessoa: "",
            codigo_cfop: "",
            exigibilidade: "",
            item_servico: "",
            incentivo_fiscal: "",
            aliquota: "",
          },
        ],
        ibs_cbs: [
          {
            tipo_pessoa: "padrao",
            cenario: "padrao",
            situacao_tributaria: "000",
            situacao_tributaria_regular: '000',
            classificacao_tributaria: "000001",
            classificacao_tributaria_regular: "000001",
            ibs_estadual: {
              aliquota_diferimento: 0,
            },
            ibs_municipal: {
              aliquota_diferimento: 0,
            },
            cbs: {
              aliquota_diferimento: 0,
            },
            credito_presumido: {
              classificacao: "3",
              aliquota_ibs: 0,
              aliquota_cbs: 0,
            }
          },
        ],
        informacoes_fisco: "",
        informacoes_complementares: "",
      },
      imposto_manual: initialStateInfoFiscal.imposto_manual
    }

    return JSON.parse(JSON.stringify(result))
  }

  handleTaxFromEdit(infoFiscal, tax) {
    return {
      ref: tax.ref,
      icms: tax.refObject.icms ? [{ ...infoFiscal.icms[0], ...tax.refObject.icms[0] }] : infoFiscal.icms,
      ipi: tax.refObject.ipi ? [{ ...infoFiscal.ipi[0], ...tax.refObject.ipi[0] }] : infoFiscal.ipi,
      pis: tax.refObject.pis ? [{ ...infoFiscal.pis[0], ...tax.refObject.pis[0] }] : infoFiscal.pis,
      cofins: tax.refObject.cofins ? [{ ...infoFiscal.cofins[0], ...tax.refObject.cofins[0] }] : infoFiscal.cofins,
      issqn: tax.refObject.issqn ? [{ ...infoFiscal.issqn[0], ...tax.refObject.issqn[0] }] : infoFiscal.issqn,
      ibs_cbs: tax.refObject.ibs_cbs ? [{ ...infoFiscal.ibs_cbs[0], ...tax.refObject.ibs_cbs[0] }] : infoFiscal.ibs_cbs,
      informacoes_fisco: tax.refObject.informacoes_fisco,
      informacoes_complementares: tax.refObject.informacoes_complementares,
      descricao: tax.refObject.descricao,
    }
  }
  handleIbsCbs(tax) {
    if (!tax?.ibs_cbs?.length) {
      return tax;
    }

    const ibsCbsObj = tax.ibs_cbs[0];
    const situacao = ibsCbsObj.situacao_tributaria;

    if (situacao !== '510' && situacao !== '550') {
      delete ibsCbsObj.classificacao_tributaria_regular;
      delete ibsCbsObj.situacao_tributaria_regular;
      delete ibsCbsObj.ibs_estadual;
      delete ibsCbsObj.ibs_municipal;
      delete ibsCbsObj.cbs;
      delete ibsCbsObj.credito_presumido;
    }

    return tax;
  }
  handleAliquots(tax) {
    if (tax?.icms[0]?.aliquota_icms?.length) {
      tax.icms[0].aliquota_icms[0].aliquota = tax?.icms[0]?.aliquota_icms[0]?.aliquota.replace(',', '.')
    }

    if (tax?.icms[0]?.aliquota_reducao) {
      tax.icms[0].aliquota_reducao = tax.icms[0]?.aliquota_reducao.replace(',', '.')
    }

    if (tax?.icms[0]?.aliquota_reducao_st) {
      tax.icms[0].aliquota_reducao_st = tax.icms[0]?.aliquota_reducao_st.replace(',', '.')
    }

    if (tax?.pis[0]?.aliquota) {
      tax.pis[0].aliquota = tax?.pis[0]?.aliquota.replace(',', '.')
    }

    if (tax?.ipi[0]?.aliquota) {
      tax.ipi[0].aliquota = tax?.ipi[0]?.aliquota.replace(',', '.')
    }

    if (tax?.cofins[0]?.aliquota) {
      tax.cofins[0].aliquota = tax?.cofins[0]?.aliquota.replace(',', '.')
    }

    return tax
  }
}

export default new HandleTaxNotaFIscal()
